import { useEffect } from 'react';
import { assets, localize, productById } from './products';

export function useMetadata(page, lang) {
  useEffect(() => {
    const product = productById[page];
    if (!product) return;
    const oldTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const oldDescription = meta?.content;
    document.title = `${product.name} · ${product.battery} | KisanDrone`;
    if (meta) meta.content = `${product.name} — ${localize(product.fit, lang)}. ${product.battery} · ${localize(product.tank, lang)} · RTK: ${localize(product.rtk, lang)}.`;
    const schema = document.createElement('script');
    schema.type = 'application/ld+json'; schema.id = 'v3-product-data';
    schema.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'Product', name: product.name, image: assets[product.img], brand: { '@type': 'Brand', name: 'KisanDrone' }, additionalProperty: [['Battery system', product.battery], ['Tank', localize(product.tank, lang)], ['Body', localize(product.body, lang)], ['RTK', localize(product.rtk, lang)]].map(([name, value]) => ({ '@type': 'PropertyValue', name, value })) });
    document.head.append(schema);
    return () => { document.title = oldTitle; if (meta) meta.content = oldDescription; schema.remove(); };
  }, [page, lang]);
}